import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const PaymentMethodIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2 4.3501H15.4M22.6 20.3501V21.5501C22.6 22.6547 21.7046 23.5501 20.6 23.5501H3C1.89543 23.5501 1 22.6547 1 21.5501V6.3501C1 5.24553 1.89543 4.3501 3 4.3501H7.6"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M22.6 12.7502V9.95019C22.6 8.84562 21.7046 7.9502 20.6 7.9502H1"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M17.8008 12.75H23.0008C24.1053 12.75 25.0008 13.6454 25.0008 14.75V15.55C25.0008 16.6546 24.1054 17.55 23.0008 17.55H17.8008V12.75Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M19 7.9502L12.6882 2.06064C11.9036 1.3285 10.6809 1.34611 9.91772 2.10055L4 7.9502"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default PaymentMethodIcon;
